// use by community components to check user token balance via backend API

import authService from './authService.js';
import { frontendLogger } from '../../services/frontendLogger.js';
import { urlConfig } from '../../config/urlConfig.js';

/**
 * Token service for checking user token balance via backend API
 */
export const tokenService = {
  /**
   * Check user's token balance from backend API
   * @returns {Promise<{amount_remaining: number, amount_used: number, total: number}>}
   */
  async checkTokenBalance() {
    try {
      const user = authService.getUser();
      const token = authService.getToken();
      
      if (!user || !token) {
        throw new Error('User not authenticated');
      }

      const response = await fetch(`${urlConfig.api.baseURL}/api/tokens/balance`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      
      return {
        amount_remaining: data.usage_summary?.remaining || 0,
        amount_used: data.usage_summary?.total_used || 0,
        total: (data.usage_summary?.remaining || 0) + (data.usage_summary?.total_used || 0)
      };
    } catch (error) { 
      frontendLogger.error('Error checking token balance', {
        error: error.message,
        stack: error.stack,
        user_id: authService.getUser()?.id
      }, 'tokenService');
      return { amount_remaining: 0, amount_used: 0, total: 0 };
    }
  }
};

export default tokenService;